export default __webpack_public_path__ + "static/media/doc-home.4fd312c6.svg";